import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/store'

// Most route components are lazy loaded
import Home from '../views/HomePage/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/ingresar',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '../views/LoginPage/Login.vue'),
        meta: {
            requiresAnonymous: true
        }
    },
    {
        path: '/recuperar-contrasena',
        name: 'recover-password',
        component: () => import(/* webpackChunkName: "recover-password" */ '../views/RecoverPasswordPage/RecoverPassword.vue'),
        meta: {
            requiresAnonymous: true
        }
    },
    {
        path: '/reiniciar-contrasena/:resetToken',
        name: 'reset-password',
        component: () => import(/* webpackChunkName: "reset-password" */ '../views/ResetPasswordPage/ResetPassword.vue'),
        meta: {
            requiresAnonymous: true
        }
    },
    {
        path: '/preferencias',
        name: 'user-settings',
        component: () => import(/* webpackChunkName: "user-settings" */ '../views/UserSettingsPage/UserSettings.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administracion',
        name: 'admin',
        component: () => import(/* webpackChunkName: "admin-courses" */ '../views/AdminPage/Admin.vue'),
        redirect: { name: 'admin-courses' },
        meta: {
            requiresAdmin: true
        },
        children: [
            {
                path: 'asignaturas',
                name: 'admin-courses',
                component: () => import(/* webpackChunkName: "admin-courses" */ '../views/AdminPage/AdminCourses.vue'),
                redirect: { name: 'admin-courses-list' },
                children: [
                    {
                        path: '',
                        name: 'admin-courses-list',
                        component: () => import(/* webpackChunkName: "admin-courses-list" */ '../views/AdminPage/AdminCoursesList.vue')
                    },
                    {
                        path: 'crear',
                        name: 'admin-courses-create',
                        component: () => import(/* webpackChunkName: "admin-courses-create" */ '../views/AdminPage/AdminCoursesCreate.vue')
                    },
                    {
                        path: 'editar/:courseCode',
                        name: 'admin-courses-edit',
                        component: () => import(/* webpackChunkName: "admin-courses-edit" */ '../views/AdminPage/AdminCoursesEdit.vue')
                    }
                ]
            },
            {
                path: 'estudiantes',
                name: 'admin-students',
                component: () => import(/* webpackChunkName: "admin-students" */ '../views/AdminPage/AdminStudents.vue'),
                redirect: { name: 'admin-students-list' },
                children: [
                    {
                        path: '',
                        name: 'admin-students-list',
                        component: () => import(/* webpackChunkName: "admin-students-list" */ '../views/AdminPage/AdminStudentsList.vue')
                    },
                    {
                        path: 'crear',
                        name: 'admin-students-create',
                        component: () => import(/* webpackChunkName: "admin-students-create" */ '../views/AdminPage/AdminStudentsCreate.vue')
                    },
                    {
                        path: 'editar/:studentIdCardNumber',
                        name: 'admin-students-edit',
                        component: () => import(/* webpackChunkName: "admin-students-edit" */ '../views/AdminPage/AdminStudentsEdit.vue'),
                        redirect: { name: 'admin-students-edit-form' },
                        children: [
                            {
                                path: '',
                                name: 'admin-students-edit-form',
                                component: () => import(/* webpackChunkName: "admin-students-edit" */ '../views/AdminPage/AdminStudentsEditForm.vue')
                            },
                            {
                                path: 'editar-contrasena',
                                name: 'admin-students-edit-password',
                                component: () => import(/* webpackChunkName: "admin-students-edit" */ '../views/AdminPage/AdminStudentsEditPassword.vue')
                            }
                        ]
                    }
                ]
            },
            {
                path: 'docentes',
                name: 'admin-professors',
                component: () => import(/* webpackChunkName: "admin-professors" */ '../views/AdminPage/AdminProfessors.vue'),
                redirect: { name: 'admin-professors-list' },
                children: [
                    {
                        path: '',
                        name: 'admin-professors-list',
                        component: () => import(/* webpackChunkName: "admin-professors-list" */ '../views/AdminPage/AdminProfessorsList.vue')
                    },
                    {
                        path: 'crear',
                        name: 'admin-professors-create',
                        component: () => import(/* webpackChunkName: "admin-professors-create" */ '../views/AdminPage/AdminProfessorsCreate.vue')
                    },
                    {
                        path: 'editar/:professorIdCardNumber',
                        name: 'admin-professors-edit',
                        component: () => import(/* webpackChunkName: "admin-professors-edit" */ '../views/AdminPage/AdminProfessorsEdit.vue'),
                        redirect: { name: 'admin-professors-edit-form' },
                        children: [
                            {
                                path: '',
                                name: 'admin-professors-edit-form',
                                component: () => import(/* webpackChunkName: "admin-professors-edit" */ '../views/AdminPage/AdminProfessorsEditForm.vue')
                            },
                            {
                                path: 'editar-contrasena',
                                name: 'admin-professors-edit-password',
                                component: () => import(/* webpackChunkName: "admin-professors-edit" */ '../views/AdminPage/AdminProfessorsEditPassword.vue')
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: '/asignatura/:courseCode/nuevo-sitio',
        name: 'create-site',
        component: () => import(/* webpackChunkName: "create-site" */ '../views/CreateSite/CreateSite.vue'),
        meta: {
            requiresAuth: true,
            requiresTeachingStaffPermission: true
        }
    },
    {
        path: '/asignatura/:courseCode/:academicPeriod',
        name: 'site',
        component: () => import(/* webpackChunkName: "site" */ '../views/SitePage/Site.vue'),
        redirect: { name: 'site-general-info' },
        children: [
            {
                path: '',
                name: 'site-general-info',
                component: () => import(/* webpackChunkName: "site-general-info" */ '../views/SitePage/subpages/SiteGeneralInfo/SiteGeneralInfo.vue')
            },
            {
                path: 'contenido-tematico',
                name: 'site-thematic-content',
                component: () => import(/* webpackChunkName: "site-thematic-content" */ '../views/SitePage/subpages/SiteThematicContent/SiteThematicContent.vue')
            },
            {
                path: 'grupo-docente',
                name: 'site-teachers-staff',
                component: () => import(/* webpackChunkName: "site-teaching-staff" */ '../views/SitePage/subpages/SiteTeachingStaff/SiteTeachingStaff.vue')
            },
            {
                path: 'horarios',
                name: 'site-timetables',
                component: () => import(/* webpackChunkName: "site-timetables" */ '../views/SitePage/subpages/SiteTimetables/SiteTimetables.vue')
            },
            {
                path: 'estudiantes',
                name: 'site-students',
                component: () => import(/* webpackChunkName: "site-students" */ '../views/SitePage/subpages/SiteStudents/SiteStudents.vue'),
                meta: {
                    requiresAuth: true,
                    requiresStudentTeacherOrBetter: true
                }
            },
            {
                path: 'evaluaciones',
                name: 'site-evaluations',
                component: () => import(/* webpackChunkName: "site-evaluations" */ '../views/SitePage/subpages/SiteEvaluations/SiteEvaluations.vue')
            },
            {
                path: 'encuestas-quices/docentes',
                name: 'site-teacher-surveys',
                component: () => import(/* webpackChunkName: "site-surveys-teaching-staff" */ '../views/SitePage/subpages/SiteSurveys/TeachingStaffSurveys.vue'),
                redirect: { name: 'site-teacher-surveys-list' },
                meta: {
                    requiresAuth: true,
                    requiresStudentTeacherOrBetter: true
                },
                children: [
                    {
                        path: '',
                        name: 'site-teacher-surveys-list',
                        component: () => import(/* webpackChunkName: "site-surveys-teaching-staff" */ '../views/SitePage/subpages/SiteSurveys/subpages/TeachingStaff/TeachingStaffSurveysList.vue')
                    },
                    {
                        path: ':surveyId',
                        name: 'site-teacher-surveys-detail',
                        component: () => import(/* webpackChunkName: "site-surveys-teaching-staff" */ '../views/SitePage/subpages/SiteSurveys/subpages/TeachingStaff/TeachingStaffSurveyDetail.vue')
                    },
                    {
                        path: ':surveyId/respuestas/:studentSurveyId',
                        name: 'site-teacher-surveys-answers',
                        component: () => import(/* webpackChunkName: "site-surveys-teaching-staff" */ '../views/SitePage/subpages/SiteSurveys/subpages/TeachingStaff/TeachingStaffSurveyAnswers.vue')
                    }
                ]
            },
            {
                path: 'encuestas-quices',
                name: 'site-student-surveys',
                component: () => import(/* webpackChunkName: "site-surveys-students" */ '../views/SitePage/subpages/SiteSurveys/StudentSurveys.vue'),
                redirect: { name: 'site-student-surveys-list' },
                meta: {
                    requiresAuth: true,
                    requiresStudentOrBetter: true
                },
                children: [
                    {
                        path: '',
                        name: 'site-student-surveys-list',
                        component: () => import(/* webpackChunkName: "site-surveys-students" */ '../views/SitePage/subpages/SiteSurveys/subpages/Students/StudentsSurveysList.vue')
                    },
                    {
                        path: ':surveyId',
                        name: 'site-student-surveys-detail',
                        component: () => import(/* webpackChunkName: "site-surveys-students" */ '../views/SitePage/subpages/SiteSurveys/subpages/Students/StudentsSurveyDetail.vue')
                    }
                ]
            },
            {
                path: 'entregas',
                name: 'site-assignments',
                component: () => import(/* webpackChunkName: "site-assignments" */ '../views/SitePage/subpages/SiteAssignments/SiteAssignments.vue')
            },
            {
                path: 'planificacion',
                name: 'site-scheduling',
                component: () => import(/* webpackChunkName: "site-scheduling" */ '../views/SitePage/subpages/SiteScheduling/SiteScheduling.vue')
            },
            {
                path: 'calificaciones',
                name: 'site-grades',
                component: () => import(/* webpackChunkName: "site-grades" */ '../views/SitePage/subpages/SiteGrades/SiteGrades.vue'),
                meta: {
                    requiresAuth: true,
                    requiresStudentOrBetter: true
                }
            },
            {
                path: 'noticias',
                name: 'site-news',
                component: () => import(/* webpackChunkName: "site-news" */ '../views/SitePage/subpages/SiteNews/SiteNews.vue')
            },
            {
                path: 'foros',
                name: 'site-forums',
                component: () => import(/* webpackChunkName: "site-forums" */ '../views/SitePage/subpages/SiteForums/SiteForums.vue'),
                meta: {
                    requiresAuth: true,
                    requiresStudentOrBetter: true
                }
            },
            {
                path: 'descargas',
                name: 'site-downloads',
                component: () => import(/* webpackChunkName: "site-downloads" */ '../views/SitePage/subpages/SiteDownloads/SiteDownloads.vue')
            },
            {
                path: 'enviar-correo',
                name: 'site-send-email',
                component: () => import(/* webpackChunkName: "site-send-email" */ '../views/SitePage/subpages/SiteSendEmail.vue'),
                meta: {
                    requiresAuth: true,
                    requiresStudentTeacherOrBetter: true
                }
            },
            {
                path: 'registro-de-actividad',
                name: 'site-logs',
                component: () => import(/* webpackChunkName: "site-logs" */ '../views/SitePage/subpages/SiteLogs.vue'),
                meta: {
                    requiresAuth: true,
                    requiresCoordOrBetter: true
                }
            },
            {
                path: 'semestres-anteriores',
                name: 'site-previous-semesters',
                component: () => import(/* webpackChunkName: "site-previous-semesters" */ '../views/SitePage/subpages/SitePreviousSemesters.vue')
            }
        ]
    },
    {
        path: '*',
        redirect: { name: 'home' }
    }
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    store.commit('SET_LOADING_COMPONENT', true)
    // Check for requiresAuth guard (User is logged in)
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters.isUserAuthenticated) {
            return next({ name: 'login' })
        }
    }

    // Check for requiresAnonymous guard (User is NOT logged in)
    if (to.matched.some(record => record.meta.requiresAnonymous)) {
        if (store.getters.isUserAuthenticated) {
            return next({ name: 'home' })
        }
    }

    // Check for requiresStudentOrBetter guard (User is registered in any role in the site or admin)
    if (to.matched.some(record => record.meta.requiresStudentOrBetter)) {
        if (!store.getters.isUserStudentOrBetter) {
            return next({ name: 'home' })
        }
    }

    // Check for requiresTeachingStaffPermission guard (User is teacherStudent, professor or coordinator)
    if (to.matched.some(record => record.meta.requiresTeachingStaffPermission)) {
        if (!store.getters.isUserTeachingStaff) {
            return next({ name: 'home' })
        }
    }

    // Check for requiresStudentTeacherOrBetter guard (User in site teaching staff or admin)
    if (to.matched.some(record => record.meta.requiresStudentTeacherOrBetter)) {
        if (!store.getters.isUserStudenTeacherOrBetter) {
            return next({ name: 'home' })
        }
    }

    // Check for requiresCoordOrBetter guard (User in site coordinator or admin)
    if (to.matched.some(record => record.meta.requiresCoordOrBetter)) {
        if (!store.getters.isUserCoordOrBetter) {
            return next({ name: 'home' })
        }
    }

    // Check for requiresAdmin guard (User is system admin)
    if (to.matched.some(record => record.meta.requiresAdmin)) {
        if (!store.getters.isUserAuthenticated || !store.getters.isUserAdmin) {
            return next({ name: 'home' })
        }
    }

    // Default behaviour if all the guard checks pass.
    next()
})

router.afterEach((to, from) => {
    store.commit('SET_LOADING_COMPONENT', false)
})

export default router
